/**
 * @generated SignedSource<<710d7b3dc2b63ab2a7f4515f4a1d253f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingHeader_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Attendees_viewer" | "JoinConferenceButton_viewer" | "MeetingTitleAndXWCSwitcher_viewer" | "MoreActionsMenu_MeetingHeader_viewer">;
  readonly " $fragmentType": "MeetingHeader_viewer";
};
export type MeetingHeader_viewer$key = {
  readonly " $data"?: MeetingHeader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingHeader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingHeader_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingTitleAndXWCSwitcher_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "JoinConferenceButton_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Attendees_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MoreActionsMenu_MeetingHeader_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "675e8c03af941c8772df8873527d3c86";

export default node;
